module.exports = __webpack_public_path__ + "static/media/driver-circle-idle.979ae5ac.svg";